import React, { Component } from "react";
import { WELCOME_OPTIONS_ID } from "../../utils/daniUtils";
import { deepClone } from "./../../utils/copyObject";
import { socketConnection } from "../../socketClient";
import { chatQuerySearchTypes } from "../../utils/constants";

class DaniOptionsStep extends Component {
  componentDidMount(){
    const {step} = this.props;

    if(step.id =="39"){
      this.props.triggerNextStep(step)
    }
  }
  handleClick = option => {
    console.log('option TEST ---- ', option)
    if (option.kpi) {
      // console.log("checkForSubCategory", option);
      //MIXPANEL CALL
      // mixpanel.track("Dani_Tool_Subcategory_Click",{
      //   kpiName : option.kpi,
      //   toolkitCategoryName : option.name,
      //   toolSubcategoryName : option.subcategory
      // });
      // Socket Event  - Dani_Tool_Subcategory_Click
      // socketConnection.track("Dani_Tool_Subcategory_Click", {
      //   kpiName : option.kpi,
      //   toolkitCategoryName : option.name,
      //   toolSubcategoryName : option.subcategory
      // });
    }
    const d = this.props.extractedText;
    // o13-ai-options
    if (
      option.id === "o14-ai" ||
      option.id === "o32-ai" ||
      option.id == "fo-4" ||
      option.id == "fo-5" 
    ) {
      this.props.setSearchType(chatQuerySearchTypes.SCRAPE);
      // this.props.setSearchType(chatQuerySearchTypes.AI_SINGLE_QUESTION);
    } else if (["fo-1", "fo-2", "fo-3"].includes(option.id)) {
      option.extractedMessage = d;
      option.isPdfExtract = true;
      this.props.actionTakenOn();

      return setTimeout(() => {
        return this.props.triggerNextStep(option);
      }, 500);
    } else if("o13-ai-options" == option.id){
      console.log('options --- ', option)
      this.props.actionTakenOn();
      return setTimeout(() => {
        return this.props.triggerNextStep(option);
      }, 500);
    }  else if (["up-yes", "up-no"].includes(option.id)) {
      this.props.actionTakenOn();
      return setTimeout(() => {
        return this.props.triggerNextStep(option);
      }, 500);
    } else {
      this.props.setSearchType(chatQuerySearchTypes.SCRAPE);
    }

    this.props.triggerNextStep(option);
  };
  render() {
    // console.log(this.props.step);
    const { options, id } = this.props.step;
    const { currentRoute, chart } = this.props;
    let displayOptions = deepClone(options);
    let disableDrillDown =
      this.props.chart.kpiType == "SURVEY_BASED" ? true : false;
    if (disableDrillDown && id == "10") {
      displayOptions.shift();
    }
    const showAction =
      currentRoute.contains("analytics") &&
      !currentRoute.contains("edit") &&
      !currentRoute.contains("create");
    if (this.props.step.id === WELCOME_OPTIONS_ID && !showAction) {
      // displayOptions.splice(1, 1);
      displayOptions = displayOptions.filter(e => e.stepType != "Analytics");
    }
    console.log("display options---", displayOptions);
    return (
      <div>
        <ul
          className="dani-option-ul"
          // style={{
          //   margin: "0 0 5px 0",
          //   paddingLeft: "48px",
          //   listStyle: "none",
          // }}
        >
          {displayOptions.map((option, idx) => {
            return (
              <li
                className="dani-option-item"
                key={option.id + idx}
                onClick={() => this.handleClick(option)}
                style={{
                  backgroundImage: option.image?`url(${option.image})`:null
                }}
              >
                {/* {option.image?
                <img src={option.image}/>:null} */}
                <div className="dani-list-overlay">
                <span className="dani-option-element">{option.label}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default DaniOptionsStep;
